import Url from 'url-parse';
import loadComponent from './loadComponent';
import domDecorator from '../../util/domDecorator';
import domDIY from '../../util/domDIY';
export default class Delivery {
  // 云查询控制投放开关
  static switch() {
    const query = new Url(window.location.href).query;
    return query.indexOf('__gray__') >= 0;
  }
  // 通过DOM操作方式渲染
  static async renderDecorator(decorator) {
    domDecorator(decorator);
  }
  // 高级模式，直接注入JS操作
  static async renderDIY(diy) {
    domDIY(diy);
  }
  static async renderOther(rule) {
    if (rule.decorator) {
      Delivery.renderDecorator(rule.decorator);
    }
    if (rule.diy) {
      Delivery.renderDIY(rule.diy);
    }
  }
  static async renderComponent(name, version, config) {
    const id = `${name}|${version}`;
    await loadComponent(id);
    const component = window.$ACE.deliveryView[name];
    if (!component) return;
    // if (config.code !== 200) return;
    await component(config);
  }
}



// WEBPACK FOOTER //
// ./src/components/delivery/index.js